(function () {
  'use strict';
  var fmtCache = null;

  function money(cents) {
    var f = (window.MENARA && window.MENARA.money) || '{{amount}} €';
    var n = (cents / 100);
    var dec = n.toFixed(2).replace('.', ',');
    var noDec = Math.round(n).toLocaleString('fr-FR');
    var withSep = dec.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return f
      .replace('{{amount_with_comma_separator}}', dec)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDec)
      .replace('{{amount_no_decimals}}', noDec)
      .replace('{{amount}}', withSep);
  }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Bandeau d'annonces ---------- */
  function announcement() {
    var el = $('[data-ann]');
    if (!el) return;
    var msgs = JSON.parse(el.getAttribute('data-ann') || '[]').filter(Boolean);
    if (msgs.length < 2) return;
    var i = 0, out = $('span', el);
    setInterval(function () {
      i = (i + 1) % msgs.length;
      var next = document.createElement('span');
      next.textContent = msgs[i];
      out.replaceWith(next);
      out = next;
    }, 4000);
  }

  /* ---------- Menu ---------- */
  function nav() {
    var b = $('[data-nav-toggle]'), d = $('[data-nav]');
    if (b && d) b.addEventListener('click', function () { d.classList.toggle('on'); });
  }

  /* ---------- Rails à flèches ---------- */
  function rails() {
    $$('[data-rail-nav]').forEach(function (wrap) {
      var rail = $('.rail', wrap);
      if (!rail) return;
      $$('[data-rail-dir]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = btn.getAttribute('data-rail-dir') === 'next' ? 1 : -1;
          rail.scrollBy({ left: d * rail.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Accordéons (FAQ + onglets produit) ---------- */
  function accordions() {
    $$('[data-acc-group]').forEach(function (group) {
      var items = $$('[data-acc]', group);
      items.forEach(function (item) {
        var btn = $('[data-acc-btn]', item);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var on = item.getAttribute('data-on') === 'true';
          items.forEach(function (o) { o.setAttribute('data-on', 'false'); });
          item.setAttribute('data-on', on ? 'false' : 'true');
          btn.setAttribute('aria-expanded', on ? 'false' : 'true');
        });
      });
    });
  }

  /* ---------- Modale guide des tailles ---------- */
  function modals() {
    $$('[data-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = document.getElementById(b.getAttribute('data-modal-open'));
        if (m) { m.classList.add('on'); document.body.style.overflow = 'hidden'; }
      });
    });
    $$('.ovl').forEach(function (ovl) {
      ovl.addEventListener('click', function (e) {
        if (e.target === ovl || e.target.hasAttribute('data-modal-close')) {
          ovl.classList.remove('on');
          document.body.style.overflow = '';
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.ovl.on').forEach(function (o) { o.classList.remove('on'); });
      document.body.style.overflow = '';
    });
  }

  /* ---------- Galerie produit ---------- */
  function gallery() {
    var gal = $('[data-gal]');
    if (!gal) return;
    var thumbs = $$('[data-gal-thumb]');
    var dots = $$('[data-gal-dot]');
    var count = $$('.gal__item', gal).length;

    function goTo(i) {
      var n = Math.max(0, Math.min(count - 1, i));
      gal.scrollTo({ left: n * gal.clientWidth, behavior: 'smooth' });
    }
    function current() { return Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)); }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    $$('[data-gal-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        goTo(current() + (b.getAttribute('data-gal-dir') === 'next' ? 1 : -1));
      });
    });

    gal.addEventListener('scroll', function () {
      var i = current();
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    });
  }

  /* ---------- Fiche produit : coloris, tailles, packs ---------- */
  function product() {
    var root = $('[data-pdp]');
    if (!root) return;

    var variants = JSON.parse($('[data-variants]', root).textContent || '[]');
    var colors = JSON.parse(root.getAttribute('data-colors') || '[]');
    var sizes = JSON.parse(root.getAttribute('data-sizes') || '[]');
    var packs = JSON.parse(root.getAttribute('data-packs') || '[]');
    var giftHandle = root.getAttribute('data-gift-id') || '';

    var state = { color: 0, size: Math.min(2, Math.max(0, sizes.length - 1)), pack: packs.length - 1, lines: [] };
    for (var i = 0; i < 3; i++) state.lines.push({ c: Math.min(i, colors.length - 1), s: state.size });

    function variantFor(ci, si) {
      var c = colors[ci], s = sizes[si];
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k];
        if ((v.option1 === c || v.option2 === c) && (v.option1 === s || v.option2 === s)) return v;
      }
      return variants[0];
    }
    function unitPrice() { var v = variantFor(state.color, state.size); return v ? v.price : 0; }
    function comparePrice() { var v = variantFor(state.color, state.size); return (v && v.compare_at_price) || unitPrice(); }

        function packTotals(p) {
      var unit = unitPrice();
      var paid = p.paid || p.qty;
      var total = p.fixed > 0 ? p.fixed : unit * paid;
      return { total: total, compare: (comparePrice() || unit) * p.qty };
    }

    function render() {
      $$('[data-swatch]', root).forEach(function (b, i) { b.setAttribute('aria-checked', i === state.color ? 'true' : 'false'); });
      $$('[data-size]', root).forEach(function (b, i) {
        b.setAttribute('aria-checked', i === state.size ? 'true' : 'false');
        var v = variantFor(state.color, i);
        if (v && v.available === false) b.setAttribute('disabled', ''); else b.removeAttribute('disabled');
      });
      var cn = $('[data-color-name]', root); if (cn) cn.textContent = colors[state.color] || '';
      var sn = $('[data-size-name]', root); if (sn) sn.textContent = sizes[state.size] || '';

      $$('[data-pack]', root).forEach(function (el, i) {
        el.setAttribute('data-on', i === state.pack ? 'true' : 'false');
        var t = packTotals(packs[i]);
        var tt = $('[data-pack-total]', el); if (tt) tt.textContent = money(t.total);
        var tc = $('[data-pack-compare]', el);
        if (tc) { tc.textContent = t.compare > t.total ? money(t.compare) : ''; tc.style.display = t.compare > t.total ? '' : 'none'; }
        $$('[data-cfg-color]', el).forEach(function (sel, k) { sel.value = String(state.lines[k].c); });
        $$('[data-cfg-size]', el).forEach(function (sel, k) { sel.value = String(state.lines[k].s); });
      });

      var p = packs[state.pack], tot = packTotals(p), save = tot.compare - tot.total;
      var set = function (sel, val) { var e = $(sel, root); if (e) e.textContent = val; };
      set('[data-price]', money(tot.total));
      var cmp = $('[data-price-compare]', root);
      if (cmp) { cmp.textContent = money(tot.compare); cmp.style.display = save > 0 ? '' : 'none'; }
      var dsc = $('[data-discount]', root);
      if (dsc) {
        dsc.textContent = '−' + Math.round(save / tot.compare * 100) + ' %';
        dsc.style.display = save > 0 ? '' : 'none';
      }
      set('[data-unit]', money(tot.total / p.qty) + ' la pièce · ' + p.qty + (p.qty > 1 ? ' pièces' : ' pièce'));
      var sv = $('[data-save]', root);
      if (sv) { sv.textContent = '· Vous économisez ' + money(save); sv.style.display = save > 0 ? '' : 'none'; }
      $$('[data-cta-price]').forEach(function (e) { e.textContent = money(tot.total); });
      var st = $('[data-sticky-variant]');
      if (st) st.textContent = (colors[state.color] || '') + ' · Taille ' + (sizes[state.size] || '');
    }

    $$('[data-swatch]', root).forEach(function (b, i) {
      b.addEventListener('click', function () { state.color = i; state.lines[0].c = i; render(); });
    });
    $$('[data-size]', root).forEach(function (b, i) {
      b.addEventListener('click', function () {
        state.size = i;
        state.lines.forEach(function (l) { l.s = i; });
        render();
      });
    });
    $$('[data-pack]', root).forEach(function (el, i) {
      var btn = $('[data-pack-btn]', el);
      if (btn) btn.addEventListener('click', function () { state.pack = i; render(); });
      $$('[data-cfg-color]', el).forEach(function (sel, k) {
        sel.addEventListener('change', function () { state.lines[k].c = Number(sel.value); render(); });
      });
      $$('[data-cfg-size]', el).forEach(function (sel, k) {
        sel.addEventListener('change', function () { state.lines[k].s = Number(sel.value); render(); });
      });
    });

    function add() {
      var p = packs[state.pack];
      var items = [];
      var counts = {};
      for (var i = 0; i < p.qty; i++) {
        var l = state.lines[i] || state.lines[0];
        var v = variantFor(l.c, l.s);
        if (!v) continue;
        counts[v.id] = (counts[v.id] || 0) + 1;
      }
      Object.keys(counts).forEach(function (id) {
        items.push({ id: Number(id), quantity: counts[id], properties: { 'Offre': p.title } });
      });
      if (p.qty >= 3 && giftHandle) items.push({ id: Number(giftHandle), quantity: 1, properties: { 'Cadeau': 'Offert avec le trio' } });

      $$('[data-cta]').forEach(function (b) { b.setAttribute('disabled', ''); });
      fetch(window.MENARA.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { window.location.href = window.MENARA.routes.cart; })
        .then(function () { $$('[data-cta]').forEach(function (b) { b.removeAttribute('disabled'); }); });
    }
    $$('[data-cta]').forEach(function (b) { b.addEventListener('click', add); });

    render();
  }

  /* ---------- Panier tiroir + compte à rebours ---------- */
  var timerId = null;

  function startTimer() {
    var el = $('[data-timer]');
    if (!el) return;
    var minutes = Number(el.getAttribute('data-minutes') || 5);
    var left = minutes * 60;
    clearInterval(timerId);
    function paint() {
      var m = String(Math.floor(left / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      el.textContent = 'Panier réservé pendant ' + m + ':' + s;
      el.setAttribute('data-urgent', left <= 60 ? 'true' : 'false');
    }
    paint();
    timerId = setInterval(function () {
      left = left > 0 ? left - 1 : minutes * 60;
      paint();
    }, 1000);
  }

  function openCart() {
    var d = $('#cart-drawer');
    if (!d) return;
    d.classList.add('on');
    document.body.style.overflow = 'hidden';
    startTimer();
  }

  function refreshCart() {
    return fetch('?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-drawer');
        var cur = $('#cart-drawer');
        if (fresh && cur) {
          var wasOn = cur.classList.contains('on');
          cur.innerHTML = fresh.innerHTML;
          if (wasOn) cur.classList.add('on');
          bindCart();
          var n = fresh.getAttribute('data-count') || '0';
          cur.setAttribute('data-count', n);
          $$('[data-cart-count]').forEach(function (e) { e.textContent = n; });
        }
      });
  }

  function bindCart() {
    var d = $('#cart-drawer');
    if (!d) return;
    $$('[data-qty]', d).forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-key');
        var q = Number(b.getAttribute('data-qty'));
        fetch(window.MENARA.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: q })
        }).then(function () { return refreshCart(); });
      });
    });
    $$('[data-upsell]', d).forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('disabled', '');
        fetch(window.MENARA.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-upsell')), quantity: 1 }] })
        }).then(function () { return refreshCart(); });
      });
    });
    if (d.classList.contains('on')) startTimer();
  }

  function cart() {
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    var d = $('#cart-drawer');
    if (d) {
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.hasAttribute('data-cart-close')) {
          d.classList.remove('on');
          document.body.style.overflow = '';
          clearInterval(timerId);
        }
      });
    }
    bindCart();
  }

  function init() {
    announcement(); nav(); rails(); accordions(); modals(); gallery(); product(); cart();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
